import { useMemo } from 'react';
import { getVisibleTabsConfig, getTabByPath, getPathByTab } from './profileUtils';
import { useHistory } from 'react-router-dom';

export function useVisibleTabs ({ isFederated, location }) {
    const history = useHistory();

    const tabs = useMemo(() => getVisibleTabsConfig(isFederated), [isFederated]);
    const tabIndex = getTabByPath({path: location.pathname, isFederated});

    function updateTab (newTabIndex) {
        const path = getPathByTab({tabIndex: newTabIndex, isFederated});
        history.push(path);
    }

    return {
        tabs,
        tabIndex,
        updateTab,
    };
}
